export default "__VITE_ASSET__C2LthU2x__"